import React from "react";
import BBIconTemplate from "./BBIconTemplate";

//change following import to change the image
import { ReactComponent as CustomIcon } from './raw/np_edit_1072354_000000.svg';
// import {Tooltip} from "@material-ui/core";
import {BRCustomizedTooltip as Tooltip} from "../../components/customBreachBits/accents/BRCustomizedTooltip";


const Icon = (props) => {
    const {style, className} = props;
    return <Tooltip title={``}>
        <span>
            <BBIconTemplate
                style={style}
                className={className}
                customIcon={CustomIcon}
            />
        </span>
    </Tooltip>
}

export default Icon;